import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedZorroModule } from '../../../shared-zorro.module';
import { RouterModule, Router, ActivatedRoute } from '@angular/router';
import { environment } from '../../../../environments/environment';
import { UserService } from '../../../service/user.service';
import html2canvas from 'html2canvas';

@Component({
  selector: 'app-print',
  standalone: true,
  imports: [CommonModule, SharedZorroModule, RouterModule],
  templateUrl: './print.component.html',
  styleUrl: './print.component.less',
})
export class PrintComponent {
  caseId: string = '';
  qcCodeURL: string = '';
  studyUID: string = '';
  caseDetail: any = {};
  constructor(private route: ActivatedRoute, private userService: UserService) {
    this.route.params.subscribe((params) => {
      this.caseId = params['id']; // 获取路由参数中的 id
    });
  }

  ngOnInit() {
    this.getQrCode();
    this.getCaseDetail();
  }

  //获取报告二维码
  getQrCode() {
    this.qcCodeURL = environment.host + '/portal/api/v1/portal/examinations/' + this.caseId + '/shareQrCode';
  }

  //获取检查详情
  getCaseDetail() {
    this.userService.getCaseDetail({ id: this.caseId }).subscribe((res) => {
      this.caseDetail = res.data;
      this.studyUID = this.caseDetail.studyInstanceUID;
    });
  }

  //上传报告截图至服务器
  uploadReportImg() {
    let dom = document.getElementById('printContent');
    this.getCanvas(dom).then((canvas: any) => {
      // canvas转base64
      let base64 = canvas.toDataURL('image/png');
      this.uploadBlob(base64);
    });
  }

  uploadBlob(data: any) {
    let params = {
      examinationId: this.caseId,
      file: data,
    };
    this.userService.uploadReportImg(params).subscribe((res) => {
      if (res.code === 0) {
        console.log('上传成功');
        this.print();
      }
    });
  }

  //打印指定区域
  print() {
    let dom = document.getElementById('printContent');
    this.getCanvas(dom).then((canvas: any) => {
      let base64 = canvas.toDataURL('image/png');
      let img = new Image();
      img.src = base64;
      img.onload = () => {
        console.log('打印');
        let printWindow: any = window.open('', '_blank');
        let title = '云起医澜数字胶片-' + this.caseDetail.patientName + '-' + this.caseDetail.patientId;
        printWindow.document.write('<style>body{background:#a3a3a3}</style><title>' + title + '</title><div style="text-align:center;"><img src="' + base64 + '" style="210mm;height:297mm;"></div>');
        printWindow.document.close();
        setTimeout(() => {
          printWindow.print();
          printWindow.close();
        }, 200);
      };
    });
  }

  //获取指定DOM的canvas
  getCanvas(dom: any) {
    return new Promise((resolve) => {
      html2canvas(dom, {
        useCORS: true,
        allowTaint: false,
        backgroundColor: '#fff',
        scale: 2,
        scrollX: 0,
        scrollY: 0,
        width: dom.offsetWidth,
        height: dom.offsetHeight,
      }).then((canvas) => {
        resolve(canvas);
      });
    });
  }
}
